export const JSM_FEEDBACK_GROUP_ID = 'jsm.board';
export const JSW_BOARD_FEEDBACK_GROUP_ID = 'jsw.board';
